:host {
  display: block;
}

h5 {
  font-family:'Lato';
  font-weight:'medium';
  line-height:130%;
  font-size:25px;
  letter-spacing:0;
  text-decoration:none;
}